
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

// > services/types <
import { WaybillCar } from '@/modern/modules/m-dispatcher-module/services/types/waybill.types'

export default defineComponent({
    props: {
        car: {
            type: [Object, null] as PropType<WaybillCar | null>,
            default: null
        },
    }
})
